import { render } from "./LoanOffers.vue?vue&type=template&id=34dba954&ts=true"
import script from "./LoanOffers.vue?vue&type=script&lang=ts"
export * from "./LoanOffers.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__